import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

/**
 * The outlined search field used above a filterable list. The caller owns the control, so it
 * stays free to debounce, reset or read the term however it likes.
 */
@Component({
  selector: 'csi-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss']
})
export class SearchBarComponent {
  @Input() searchControl: FormControl;
  /** Translation keys, resolved against the default scope. */
  @Input() label: string;
  @Input() placeholder = 'Search...';

  public clear() {
    this.searchControl.setValue('');
  }
}
